export function hasAreaSearchParams(params: URLSearchParams): boolean {
    return (
        params.getAll('location').length > 0 ||
        (!!params.get('lat') && !!params.get('lon') && !!params.get('radius')) ||
        !!params.get('polylocation')
    );
}

const AREA_SEARCH_PARAM_KEYS = ['location', 'lat', 'lon', 'radius', 'polylocation'] as const;

export function getAreaSearchParams(params: URLSearchParams): URLSearchParams {
    const areaParams = new URLSearchParams();

    for (const key of AREA_SEARCH_PARAM_KEYS) {
        for (const value of params.getAll(key)) areaParams.append(key, value);
    }

    return areaParams;
}
